export class ConstantValue {
    public static readonly MAP_WEBSOCKET_TOKEN = 'map_access_token';

    public static readonly PAGINATION_TOTAL_RECORDS = 5000;

    // Below static value is used when in the form we want default values in the date picker or time picker or date time range picker
    public static readonly CURRENT_DATE_TIME = 'current_date_time';
}
